<template>
  <Column
    :fields="mgnlProps.fields"
    :horizontal-position="mgnlProps.horizontalPosition"
    :vertical-position="mgnlProps.verticalPosition"
    :margin="mgnlProps.margin"
    :margin-y="mgnlProps.marginY"
    :margin-mobile="mgnlProps.marginMobile"
    :margin-mobile-y="mgnlProps.marginMobileY"
  />
</template>

<script lang="ts" setup>
import Column from './Column.vue';
import { ColumnBuilder, WrapperProps } from '~/components/Shared/MagnoliaElements/Column/Column.model';

const props = defineProps(WrapperProps);
const mgnlProps = ColumnBuilder.build(props);
</script>
